import adapter from './adapter'
import { initialPaginationState } from '@/store/pagination'

export default {
  resume: null,
  resumeByMonth: null,
  collection: adapter.getInitialState(),
  pagination: initialPaginationState(),
}
